import React, { useEffect, useRef, useState } from "react";
import { SidebarContainer } from "../../../components";

const FirstSteps = () => {
  const headerRef = useRef();
  const [headerContext, setHeaderContext] = useState();

  useEffect(() => {
    setHeaderContext(headerRef.current);
  }, [headerRef.current]);

  const renderTabHeader = (headerProps) => {
    return <div ref={headerRef}></div>;
  };

  return (
    <SidebarContainer hideSidebar header={renderTabHeader}>
      {({ parentHeight, parentWidth }) => {
        const offsetTop = headerContext?.offsetTop || 0;
        const offsetHeight = headerContext?.offsetHeight || 0;

        return (
          <div className="h-full overflow-y-auto w-full">
            <div className="w-full px-4 sm:px-6 lg:px-8 py-12">
              <div className="max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-gray-900 mb-6">
                  First Steps with Attune
                </h1>

                <div className="prose prose-lg">
                  <h2>Getting Started</h2>
                  <p>
                    Welcome to Attune! This guide will help you get up and
                    running quickly.
                  </p>

                  <h3>1. Account Setup</h3>
                  <p>
                    Learn how to set up your account and configure your
                    preferences.
                  </p>

                  <h3>2. Basic Navigation</h3>
                  <p>
                    Understand the main interface and how to navigate through
                    Attune.
                  </p>

                  <h3>3. Your First Job</h3>
                  <p>
                    Step-by-step guide to creating and managing your first job.
                  </p>

                  <h2>Next Steps</h2>
                  <p>
                    Once you're comfortable with the basics, check out our User
                    Guide for more detailed information about all of Attune's
                    features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </SidebarContainer>
  );
};

export default FirstSteps;
